<template>
  <transition name="fade" v-on:after-enter="afterEnter">
    <div class="submit_notification__wrapper" v-if="isActive">
      <div class="submit_notification__container">
        <img class="submit_notification__icon" src="/img/done-white.svg" />
        <p class="submit_notification__text">
          {{ $t('registrationCompleted') }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SubmitNotification',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    onEntered: {
      type: Function,
      required: true,
    },
  },
  methods: {
    afterEnter: function (el) {
      this.onEntered()
    },
  },
}
</script>

<style scoped>
.submit_notification__wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.submit_notification__container {
  width: 224px;
  height: 224px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.6);
  position: relative;
}

.submit_notification__icon {
  width: 98px;
  height: 98px;
  margin: auto;
  display: block;
  margin-top: 50px;
}

.submit_notification__text {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
